import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutList, LayoutGrid } from 'lucide-react';
import { cn } from '@/utils/cn';

const LeadViewSwitcher: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isListView = location.pathname === '/leads';
  const isPipelineView = location.pathname === '/pipeline';

  return (
    <div className="flex items-center gap-1 p-1 bg-gray-100 dark:bg-gray-800 rounded-lg">
      {/* List View Button */}
      <button
        onClick={() => navigate('/leads')}
        className={cn(
          'flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-all',
          isListView
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
        )}
        title="List View"
      >
        <LayoutList className="w-4 h-4" />
        <span>List</span>
      </button>

      {/* Pipeline View Button */}
      <button
        onClick={() => navigate('/pipeline')}
        className={cn(
          'flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-all',
          isPipelineView
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
        )}
        title="Pipeline View"
      >
        <LayoutGrid className="w-4 h-4" />
        <span>Pipeline</span>
      </button>
    </div>
  );
};

export default LeadViewSwitcher;
